

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class authCloudService {

    constructor(private http: HttpClient, private router: Router) { }

    getDropboxCode() {
        let client_id: string = 'mocs2y3x16eml9j'
        let redirect_uri = window.location.origin+ '/manage/storage/add-cloud/dropbox';
        window.location.href = `https://www.dropbox.com/oauth2/authorize?client_id=${client_id}&response_type=code&redirect_uri=${redirect_uri}`;
    }
}